import request from "@/utils/request";

// 获取活动列表
export function getEventList() {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/event/list`,
    method: "get",
  });
}

// 获取活动id
export function getEventId(cmsId) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/event/getEventId?cmsId=${cmsId}`,
    method: "get",
  });
}
// 获取活动下院校列表
export function getEventSchoolList(eventId) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/event/querySchoolListByEvemtId?eventId=${eventId}`,
    method: "get",
  });
}

// 获取活动日程
export function getEventSchedule(eventId, scheduleProcessType) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/detail?id=${eventId}&scheduleProcessType=${scheduleProcessType}`,
    method: "get",
  });
}

// 通过日程id获取动态表单对应日程key的token及表单地址
export function getEventScheduleTokenFormUrl(id) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/getEventScheduleTokenFormUrl?id=${id}`,
    method: "get",
  });
}

// 获取日程下用户数据
export function getEventScheduleUser(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/getUserByScheduleId`,
    method: "post",
    data,
  });
}

// 领队提交日程下用户参赛数据
export function submitUserJoinCompMaterials(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/submitUserJoinCompMaterials`,
    method: "post",
    data,
  });
}

// 领队退回日程下用户参赛数据
export function backUserJoinCompMaterials(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/backUserJoinCompMaterials`,
    method: "post",
    data,
  });
}

// 下载报名表
export function downloadForm(eventScheduleId) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/form/getDownloadDocUrl?eventScheduleId=${eventScheduleId}`,
    method: "get",
  });
}

// 前台融合出版平台接口
// 个人查看、修改地址--融合出版平台URL
export function getBookPersonalFormUrl(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/book/getBookPersonalUrl`,
    method: "get",
    params: data,
  });
}
// 领队查看、修改地址--融合出版平台URL
export function getBookLeaderFormUrl(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/book/getBookLeaderUrl`,
    method: "get",
    params: data,
  });
}

// 上传资料
export function submitMaterials(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/submitMaterials`,
    method: "post",
    data,
  });
}
// 融合出版平台判断是否是评审专家
export function isAssociate(eventId) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/book/isAssociate?eventId=${eventId}`,
    method: "get",
  });
}

//评审专家地址
export function getBookJurorUrl(eventId) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/book/getBookJurorUrl?eventId=${eventId}`,
    method: "get",
  });
}

// 批量撤回
export function batchBack(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/cancelSubmit`,
    method: "post",
    data,
  });
}

export function getDataFormUrl(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/getDataFormUrl`,
    method: "get",
    params: data,
  });
}

//资料撤回
export function cancelMaterials(data) {
  return request({
    url: `${process.env.VUE_APP_BASE_API}/front/eventSchedule/cancelMaterials`,
    method: "post",
    data,
  });
}

batchBack;
